import React from 'react';
import './TaskForm.css';
import { formatLocalDate } from './utils/dateUtils';

function TaskViewModal({
  task,
  users = [],
  projects = [],
  onClose,
  isSubtask = false,
  variant = 'default'
}) {
  if (!task) return null;

  const getUserName = (userId) => {
    const user = users.find((item) => item._id === userId);
    return user ? user.name : '';
  };

  const getProjectName = (projectId) => {
    const project = projects.find((item) => item._id === projectId);

    if (!project) return '';

    return project.isDefault ? 'Sin proyecto' : project.name;
  };

  const formatStatus = (status) => {
    const statusLabels = {
      nueva: 'Nueva',
      trabajando: 'Trabajando',
      bloqueada: 'Bloqueada',
      pendiente: 'Pendiente',
      completada: 'Completada'
    };

    return statusLabels[String(status || '').toLowerCase()] || status || '';
  };

  const isFastView = variant === 'fast-view';
  const projectName = getProjectName(task.project);
  const responsibleName = getUserName(task.responsible);
  const validatorName = getUserName(task.validator);
  const hasNotes = Boolean(String(task.notes || '').trim());

  return (
    <div
      className={`modal-overlay${isFastView ? ' fast-view-task-modal-overlay' : ''}`}
    >
      <div
        className={`modal-content form-container edit-task-modal${isFastView ? ' fast-view-task-modal-content' : ''}`}
      >
        <h2>{isSubtask ? 'Ver Subtarea' : 'Ver Tarea'}</h2>

        <div className="form-group full-width">
          <label>Título:</label>
          <textarea
            value={task.title || ''}
            readOnly
          />
        </div>

        {!isSubtask && projectName && (
          <div className="form-group full-width">
            <label>Proyecto:</label>
            <input
              type="text"
              value={projectName}
              readOnly
            />
          </div>
        )}

        <div className="form-row">
          <div className="form-group">
            <label>Estado:</label>
            <input
              type="text"
              value={formatStatus(task.status)}
              readOnly
            />
          </div>

          {task.dueDate && (
            <div className="form-group">
              <label>Fecha de entrega:</label>
              <input
                type="text"
                value={formatLocalDate(task.dueDate)}
                readOnly
              />
            </div>
          )}
        </div>

        {(responsibleName || validatorName) && (
          <div className="form-row">
            {responsibleName && (
              <div className="form-group">
                <label>Responsable:</label>
                <input
                  type="text"
                  value={responsibleName}
                  readOnly
                />
              </div>
            )}

            {validatorName && (
              <div className="form-group">
                <label>Validador:</label>
                <input
                  type="text"
                  value={validatorName}
                  readOnly
                />
              </div>
            )}
          </div>
        )}

        {hasNotes && (
          <div className="form-group full-width">
            <label>Notas:</label>
            <textarea
              value={task.notes}
              readOnly
              rows={12}
            />
          </div>
        )}

        <div className="form-buttons">
          <button
            type="button"
            className="modal-primary-button task-view-close-button"
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default TaskViewModal;
